angular.module('b2bLoginApp.services').factory('CompanyProfilePublic', ['$resource',
    function($resource){
        return $resource('company-profile-public.json', null, {
            update: { method: 'PUT' }
        });
    }]);
